import type { UesFieldDef } from "../entities/doc-type"
import type { DocTypeRepository } from "../repositories/doc-type-repository"

type CreateDocTypeInput = {
  key: string
  displayName: string
  description: string
  uesFields: UesFieldDef[]
}

export const makeCreateDocType = (repo: DocTypeRepository) =>
  (input: CreateDocTypeInput) => repo.create(input)
